
import type { SVGProps } from "react";

interface IconProps extends SVGProps<SVGSVGElement> {
  fill?: string;
  isActive?: boolean;
}

export const FlowIcon =  ({
  fill = "#6F747B",
  isActive,
  ...restProps
}: IconProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
    {...restProps}>
    <path
      fill={fill}
className={`dark:${
        isActive
          ? "fill-primary"
          : "fill-caption group-hover:dark:fill-primary"
      }`}
      fillRule="evenodd"
      d="M13 6H9a1 1 0 0 0-1 1v1a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3v1a1 1 0 0 0 1 1h4v-1a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-3a3.001 3.001 0 0 1-2.83-2H9a3 3 0 0 1-3-3v-1H5a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3h1V7a3 3 0 0 1 3-3h4.17A3.001 3.001 0 0 1 16 2h3a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-3a3 3 0 0 1-3-3V6Zm2-1a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V5ZM4 11a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2Zm11 6a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default FlowIcon;
